import React, { useEffect } from "react";
import { Table  } from 'antd';
import Card from "components/card";
import Button from "components/button";
import CrudOption from "components/dropdown/crudoption";
import { PlusOutlined } from '@ant-design/icons';
import { connect } from "react-redux";
import { getSalaryAdjustmentList, doSalaryAdjustmentDelete } from "../../../../redux/salaryadjustment/salaryAdjustmentState";
import { NumberFormatter, handleTableChange } from "../../../../utils/index";
import ColumnSearchFilter from 'components/search/ColumnSearchFilter';
import SearchFilter from "components/search/SearchFilter";
import PopupButton from "components/button/PopupButton";
import SalaryAdjustmentForm from "./SalaryAdjustmentForm";


const SalaryAdjustmentTable = ({ recordList, pagination, doSearch, filters, doDelete }) => {  	
	const { getColumnSearchProps } = ColumnSearchFilter();
  	const columns = [
	  	{
	        title: `Employee ID`,
	        dataIndex: 'emp_code',
	        key: 'emp_code',
	        width: '10%',
	        render:(emp_code) => <span>{emp_code}</span> 
	    },
		{
	        title: `Employee Name`,
	        dataIndex: 'sdj_employee_name',
	        key: 'sdj_employee_name',
	        width: '20%',
	        sorter: true,
	        ...getColumnSearchProps('sdj_employee_name'),
	        render:(sdj_employee_name) => <span>{sdj_employee_name}</span> 
	       
	    },
	    {
	        title: `Effective Date`,
	        dataIndex: 'sdj_effective_date',
	        key: 'sdj_effective_date',
	        width: '10%',  
	        render:(sdj_effective_date) => <span>{`${sdj_effective_date}`}</span> 
	    },
	    {
	        title: `Paycode`,
	        dataIndex: 'sdj_paycode_code',
	        key: 'sdj_paycode_code',
	        width: '15%',
	        ...getColumnSearchProps('sdj_paycode_code'),
	        render: (sdj_paycode_code) => <span>{sdj_paycode_code}</span>
	       
	    },
	    {
	        title: <div className="text-right">Amount</div>,
	        dataIndex: 'sdj_amount',
	        key: 'sdj_amount',
	        width: '10%',
	       render: (sdj_amount) => <div className="text-right">{NumberFormatter(sdj_amount)}</div>
	    },
	    {
	        title: `Status`,
	        dataIndex: 'sdj_status_name',
	        key: 'sdj_status_name',
	        width: '10%',
	        render: (sdj_status_name) => <span>{sdj_status_name}</span>
	        
	    },
	    {
	        title: `Payroll Type`,
	        dataIndex: 'sdj_type_name',
	        key: 'sdj_type_name',
	        width: '13%',
	    },
	    {
	        title: <PopupButton id="add_salary_adjustment" title="Add Salary Adjustment" label="Add" btnClass="btn-small" modalWidth={1200}>
						<SalaryAdjustmentForm recordId="0" mode="edit"/>
					</PopupButton>,
	        dataIndex: 'sdj_id',
	        key: 'sdj_id',
	        width: '12%',
	        render:(sdj_id) => <CrudOption baseRoute="/console/salary-adjustments" recordId={sdj_id} deleteHandler={doDelete}/>
	    },
    ];

	useEffect(() => {
	    doSearch({paginate: pagination.per_page});
    }, [doSearch, pagination.per_page]);
    
  	return (
	    <Card extra={"w-full h-full p-4"}>
	      	<div className="h-full overflow-x-scroll xl:overflow-x-hidden">
	      	
	      		<SearchFilter searchHandler={doSearch} filters={filters} pagination={pagination}/>
	      		
	      		<Table
		        	dataSource={recordList} 
		        	columns={columns} 
		            rowKey={(record) => record.sdj_id}
		        	pagination={pagination}    
		            onChange={handleTableChange(doSearch, filters)}                  	
	        	/>
	      	</div>
	    </Card>
  );
};

const mapStateToProps = (state) => ({
  	recordList: state.salaryAdjustment.salaryAdjustmentList?.items,
  	pagination: state.salaryAdjustment.salaryAdjustmentList?.pagination,
	filters: state.salaryAdjustment.salaryAdjustmentList?.filters,
  	requesting: state.salaryAdjustment.salaryAdjustmentList?.requesting,
  	error: state.salaryAdjustment.salaryAdjustmentList?.error,
});

const mapDispatchToProps = (dispatch) => ({
	doSearch: (filters) => dispatch(getSalaryAdjustmentList(filters)),
  	doDelete: (recordId) => dispatch(doSalaryAdjustmentDelete(recordId)),
});

export default connect(mapStateToProps, mapDispatchToProps)(SalaryAdjustmentTable);